import { createContext } from 'react';

import type { MessageItemProps } from '@ergeon/core-components';

import type { AIAgentThread } from '../../types';

export interface AIAgentContextType {
  // State
  text: string;
  setText: (text: string) => void;
  messages: MessageItemProps[];
  isSubmitting: boolean;
  isLoading: boolean;
  currentThreadId: number | null;
  error: string | null;
  threads: AIAgentThread[];
  isLoadingThreads: boolean;
  hasMoreThreads: boolean;
  isDisabled: boolean;
  scrollContainerRef: React.RefObject<HTMLDivElement | null>;

  // Actions
  loadMoreThreads: () => Promise<void>;
  selectThread: (threadId: number) => Promise<void>;
  startNewConversation: () => void;
  handleDeleteThread: (threadId: number) => Promise<void>;
  handleSubmit: () => Promise<void>;
}

export const AIAgentContext = createContext<AIAgentContextType | null>(null);
